import { theme } from './theme.js';

export function MuiMeta() {
  return <meta name="theme-color" content={theme.palette.primary.main} />;
}
